import { makeAutoObservable } from "mobx"

export default class AudienceInformation {

  constructor(audienceInformation={}) {
    this.id = audienceInformation.id
    this.authentication_id = audienceInformation.authentication_id
    this.detailed_audience_stats = audienceInformation.detailed_audience_stats || null
    this.fake_follower_rate = audienceInformation.fake_follower_rate || ''


    makeAutoObservable(this)
  }
}
